var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.formattedJson)?_c('pre',{staticClass:"my-0"},[_c('code',{staticClass:"language-json pa-0"},[_vm._v(_vm._s(_vm.formattedJson))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }